export default __webpack_public_path__ + "static/media/cola-4-1-point-5.dc23974f.jpg";